// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"a2dc818e","274":"6c91e870"}[chunkId] + ".chunk.js";
};